import { addDoc, arrayRemove, collection, deleteDoc, doc, getDocs, query, setDoc, Timestamp, updateDoc, where } from "firebase/firestore";
import Category from "../models/Category";
import { db } from "../firebase";

const getCategories = async (type: "income" | "expense") => {
    const colRef = collection(db, "category");
    const q = query(colRef, where("type", "==", type));
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({ uid: doc.id, ...doc.data() }) as Category);
}

const createCategory = async (name: string, type: "income" | "expense") => {
    const colRef = doc(db, "category", name);
    const newCategory: Partial<Category> = {
        type,
        createdAt: Timestamp.fromDate(new Date()),
        updatedAt: Timestamp.fromDate(new Date()),
    }
    await setDoc(colRef, newCategory);
    return { uid: name, ...newCategory } as Category;
}

const deleteCategory = async (name: string): Promise<void> => {
    const colRef = doc(db, "category", name);
    await deleteDoc(colRef);
    const colRef2 = collection(db, "transaction");
    const q = query(colRef2, where("category", "==", name));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach(async (doc) => {
        await deleteDoc(doc.ref);
    });
    const colRef3 = collection(db, "plan");
    const q2 = query(colRef3, where("income_categories", "array-contains", name));
    const querySnapshot2 = await getDocs(q2);
    querySnapshot2.forEach(async (d) => {
        const planRef = doc(db, "plan", d.id);
        await updateDoc(planRef, {
            income_categories: arrayRemove(name)
        });
    });
    const q3 = query(colRef3, where("expense_categories", "array-contains", name));
    const querySnapshot3 = await getDocs(q3);
    querySnapshot3.forEach(async (d) => {
        const planRef = doc(db, "plan", d.id);
        await updateDoc(planRef, {
            expense_categories: arrayRemove(name)
        });
    });
    return;
}

const CategoryController = {
    getCategories,
    createCategory,
    deleteCategory,
}

export default CategoryController;